export const container = {
  flex: 4,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: '400px',
}

export const listWrapper = {
  padding: '0 8px',
  overflow: 'auto',
  height: '100%',
}
